import { render, staticRenderFns } from "./InputNumberDrag.vue?vue&type=template&id=2a660860&lang=pug"
import script from "./InputNumberDrag.vue?vue&type=script&lang=js"
export * from "./InputNumberDrag.vue?vue&type=script&lang=js"
import style0 from "./InputNumberDrag.vue?vue&type=style&index=0&id=2a660860&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports